import { type ReactNode, useState } from 'react'
import { CaretDownIcon, CaretRightIcon } from '@phosphor-icons/react'
import { Button } from 'app/components/ui/button'
import { SECTION_TITLE_CLASS } from './Section'

/** A closed-by-default section for settings almost nobody changes (design language rule 5). The
 *  `modified` dot keeps a non-default value from being invisible while the section is closed. */
export function Disclosure({ title, modified, children }: { title: string; modified?: boolean; children: ReactNode }) {
  const [open, setOpen] = useState(false)
  const Caret = open ? CaretDownIcon : CaretRightIcon
  return (
    <section className="py-4 first:pt-0 last:pb-0">
      <Button
        variant="subtle"
        size="inline"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full justify-start"
      >
        <Caret size={10} weight="bold" className="size-2.5 text-minimal" />
        <span className={SECTION_TITLE_CLASS}>{title}</span>
        {modified && !open && <span className="size-1.5 rounded-full bg-blue-500" aria-label="Changed" />}
      </Button>
      {open && <div className="mt-3 space-y-3">{children}</div>}
    </section>
  )
}
